import { render, staticRenderFns } from "./CmsIcon.vue?vue&type=template&id=47472529&"
import script from "./CmsIcon.vue?vue&type=script&lang=js&"
export * from "./CmsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports